/**
 * Keyboard shortcuts configuration with cross-platform support
 */

/**
 * Helper function to get keyboard shortcut descriptions for tooltips
 * Automatically detects Mac vs Windows/Linux for proper modifier keys
 */
export function getShortcutTooltip(action, baseText = '') {
  // Modern Mac detection using non-deprecated APIs
  const isMac = (() => {
    // Modern approach: Use navigator.userAgentData if available
    if (navigator.userAgentData) {
      return navigator.userAgentData.platform === 'macOS';
    }

    // Fallback: Use userAgent string parsing (more reliable than deprecated navigator.platform)
    return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
  })();
  const modifier = isMac ? 'Cmd' : 'Ctrl';
  const shortcuts = {
    create: 'Shift+E',
    new_entry: 'Shift+E',
    save: `${modifier}+Enter`,
    save_and_new: `${modifier}+Shift+Enter`,
    cancel: 'Esc',
    print: `${modifier}+P`
  };
  const shortcut = shortcuts[action];
  if (!shortcut) return baseText;
  return baseText ? `${baseText} (${shortcut})` : shortcut;
}

/**
 * Available keyboard shortcuts for reference
 */
export const timeEntryShortcuts = {
  newEntry: ['Shift+E'],
  save: ['Ctrl+Enter', 'Cmd+Enter'],
  saveAndNew: ['Ctrl+Shift+Enter', 'Cmd+Shift+Enter'],
  cancel: ['Escape'],
  print: ['Ctrl+P', 'Cmd+P']
};